import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { formatCurrency } from '@angular/common';
import { OrderformFascade } from '../fascades/orderform.fascade';
import { Subscription } from 'rxjs';
import { OrderformPrice } from '@orderform/widgets';

@Pipe({
  name: 'price',
})
export class PricePipe implements PipeTransform {
  private _subscription: Subscription;
  private _latestValue: string;

  constructor(
    private _orderformFascade: OrderformFascade,
    private _cd: ChangeDetectorRef
  ) {}

  transform(value: string | number | OrderformPrice): string {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }

    this._subscription = this._orderformFascade.globalSettings$.subscribe(
      (settings) => {
        if (typeof value === 'object') {
          value = settings.is_vat_shown ? value['net'] : value['gross'];
        }
        this._latestValue = formatCurrency(
          +value,
          settings.language,
          settings.currency_symbol,
          settings.currency_code,
          settings.is_show_cent_amount_part_shown === false
            ? '1.0-2'
            : undefined
        );
        this._cd.markForCheck();
      }
    );

    return this._latestValue;
  }
}
